import React from "react";
import cx from "clsx";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import FormControl, { FormControlProps } from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";

export type FormTrailerSizeProps = {
  value?: number;
  onChange?: (value: number) => void;
} & Omit<FormControlProps, "onChange">;

const FormTrailerSize = ({
  value,
  onChange,
  ...props
}: FormTrailerSizeProps) => (
  <FormControl margin="normal" fullWidth {...props}>
    <FormLabel>Trailer Size</FormLabel>
    <ButtonGroup fullWidth color={"primary"}>
      <Button
        className={cx(value === 48 && "Ptx-selected")}
        onClick={() => onChange?.(48)}
      >
        48
      </Button>
      <Button
        className={cx(value === 53 && "Ptx-selected")}
        onClick={() => onChange?.(53)}
      >
        53
      </Button>
    </ButtonGroup>
  </FormControl>
);

export default FormTrailerSize;
